/**
 * P3-28: SendExplorersButton —— Trade tab 底部探索按钮。
 *
 * 迁移自 `classes.trade.ui.SendExplorersButton` +
 * `SendExplorersButtonController`（js/diplomacy.js:1504-1547）。
 */
import { useCallback, type MouseEvent } from "react";
import { GameButton } from "../../components/GameButton";
import { useSendExplorersButtonModel } from "./useTradeModel";

export function SendExplorersButton() {
  const { snap, modelRef, controller, getTooltip } = useSendExplorersButtonModel();

  const onClick = useCallback(
    (event: MouseEvent) => {
      controller?.buyItem?.(modelRef.current, event);
    },
    [controller, modelRef],
  );

  if (!snap || !snap.visible) {
    return null;
  }

  return (
    <GameButton
      name={snap.name}
      description={snap.description}
      enabled={snap.enabled}
      resourceIsLimited={snap.resourceIsLimited}
      domClassName=" explore"
      getTooltip={getTooltip}
      onClick={onClick}
      getSelectedObject={() => modelRef.current}
    />
  );
}
